import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import { MdClose } from "react-icons/md"

import { colors } from "../colors";


export const RouteBox = styled(Box)(() => ({
  maxWidth: "none",
  margin: "0 auto",
  width: "100%",
}));

export const ModalGridContainer = () => ({
  overflow: "scroll",
  zIndex: 14,
  overflowY: "auto",
});

export const IconFaMdClose = styled(MdClose)(() => ({
  color: colors.red[80],
  opacity: 1,
  width: "1.5rem",
  height: "1.5rem",
  cursor: "pointer",
}));